'use strict';
var CommonDataService = /** @class */ (function () {
    /*@ngInject*/
    function CommonDataService($http, $q, $location, $rootScope, Util) {
        this.orderSummaryList = false;
        this.orderSummaryListStatus = false;
        this.setUserData = function (userData) {
            this.userData = userData;
        };
        this._$http = $http;
        this._$q = $q;
        this._categoriesPromise = null;
        this._$location = $location;
        this._util = Util;
        this._$rootScope = $rootScope;
    }
    // TODO: this method is a duplicate of ProductService getCategories and should be removed
    CommonDataService.prototype.getCategories = function () {
        if (this._categoriesPromise === null) {
            var deferred_1 = this._$q.defer();
            this._categoriesPromise = deferred_1.promise;
            this._$http({ method: "get", url: "api/products/categories" })
                .then(function (response) {
                if (response.data && response.data.response)
                    deferred_1.resolve(response.data.response);
                else
                    deferred_1.reject("Received an unexpected response from api/products/categories.");
            })
                .catch(function (response) { return deferred_1.reject("Failure communicating with api/products/categories."); });
        }
        return this._categoriesPromise;
    };
    CommonDataService.prototype.getRequest = function (inUrl, selfValue) {
        var _this = this;
        var deferred = this._$q.defer();
        var Util = this._util;
        this._$rootScope.loading = true;
        this._$http({
            method: 'GET',
            url: encodeURI(inUrl),
            data: {},
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            }
        }).then(function (response) {
            if (response.data && response.data.response) {
                deferred.resolve(response.data.response);
            }
            else if (response.data && response.data.errors && response.data.errors.length > 0) {
                Util.handleApiError(response, selfValue);
            }
            else {
                location.path('/timeoutErrorPage');
            }
        })
            .catch(function (response) {
            if (response.data && response.data.errors && response.data.errors.length > 0) {
                Util.handleApiError(response, selfValue);
            }
            else {
                location.path('/timeoutErrorPage');
            }
        })
            .finally(function () {
            _this._$rootScope.loading = false;
        });
        return deferred.promise;
    };
    CommonDataService.prototype.postRequest = function (inUrl, inParam, selfVal) {
        var _this = this;
        var deferred = this._$q.defer();
        var location = this._$location;
        var Util = this._util;
        var selfValue = selfVal;
        this._$rootScope.loading = true;
        return this._$http({
            method: 'POST',
            url: encodeURI(inUrl),
            data: inParam
        }).then(function (response) {
            if (_this.orderSummaryList) {
                return response;
            }
            if (response.data && response.data.response) {
                deferred.resolve(response.data.response);
            }
            else if (response.data && response.data.errors && response.data.errors.length > 0) {
                Util.handleApiError(response, selfValue);
            }
            else {
                location.path('/timeoutErrorPage');
            }
        })
            .catch(function (response) {
            if (_this.orderSummaryList) {
                if (response.status === 400) {
                    _this.orderSummaryListStatus = true;
                    return response;
                }
            }
            if (response.data && response.data.errors && response.data.errors.length > 0) {
                Util.handleApiError(response, selfValue);
            }
            else {
                location.path('/timeoutErrorPage');
            }
        })
            .finally(function () {
            _this._$rootScope.loading = false;
        });
        return deferred.promise;
    };
    CommonDataService.prototype.filterProp65Items = function (currentItem) {
        var product;
        var prod = [];
        if (this.userData && this.userData.defaultShippingAddress
            && this.userData.defaultShippingAddress.countryCode == 'US'
            && this.userData.defaultShippingAddress.regionCode == 'CA') {
            product = currentItem;
            for (var i = 0; i < currentItem.items.length; i++) {
                if (currentItem.items[i].prop65Restriction == 2) {
                    prod.push(currentItem.items[i]);
                }
            }
        }
        else {
            product = currentItem;
            for (var i = 0; i < currentItem.items.length; i++) {
                if (currentItem.items[i].prop65Restriction != 2) {
                    prod.push(currentItem.items[i]);
                }
            }
        }
        if (prod.length) {
            product.items = prod;
            return product;
        }
        else {
            return product;
        }
    };
    CommonDataService.prototype.addAttributeProductPathsForAllItems = function (items) {
        var _this = this;
        if (items == null)
            return;
        items.forEach(function (item) {
            _this.addAttributeProductPathsForSingleItem(item);
        });
    };
    CommonDataService.prototype.addAttributeProductPathsForSingleItem = function (item) {
        if (item == null)
            return;
        item.attributeNamePath = this.toPathStyle(item.attributeName);
        item.productNamePath = this.toPathStyle(item.productName || item.displayName);
    };
    CommonDataService.prototype.toPathStyle = function (stringToConvert) {
        if (stringToConvert == null)
            return '';
        return stringToConvert.toLowerCase().replace(/[^a-z0-9]/gmi, '-');
    };
    return CommonDataService;
}());
export default CommonDataService;
//# sourceMappingURL=common-data.service.js.map